<template lang='pug'>
//- 醫生推薦名單區塊
div(:class='$style[`cc-popbox-chat-additional`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.no-wrap 請選擇請求的對象

    div(:class='$style[`cc-content-list`]')
      perfect-scrollbar(:tag='`ul`' :class='$style[`cc-content-list-ul`]' ref='customScrollBarDom')
        li(v-for='items, index in consultRooms' :key='index' :class='$style[`cc-chat-additional-room-li`]')
          button(
            tabindex='0'
            aria-label='查看內容'
            @click='sendChatAdditional(items.team_id)'
            :class='$style[`cc-chat-additional-room-btn`]')
            div(:class='$style[`cc-chat-additional-room-main`]')
              figure(:class='$style[`cc-chat-additional-room-avatar`]')
                img(
                  :src='avatarSrcLink(items.thumbSrc)'
                  width='100%'
                  height='100%')
              div(:class='$style[`cc-chat-additional-room-info`]')
                span.font-bold(:class='$style[`cc-chat-additional-room-info-title`]') {{ items.vendor }}
                  //- i(v-if='items.level === `care`' :class='$style[`cc-chat-additional-room-level`]') 醫院
                span.font-regular(:class='$style[`cc-chat-additional-room-info-subtitle`]') {{ items.intro }}
            div(v-if='rwdType === `mobile`' :class='$style[`cc-chat-additional-room-panel`]')
              IconOpenArrow(:size='16' :color='`#98a1a1`')
            div(v-else :class='$style[`cc-chat-additional-room-panel`]')
              span(:class='$style[`cc-chat-additional-room-info-deliver`]') 發送請求

        //- infinite-loading(:class='$style[`cc-content-infinite-load`]' :identifier='infiniteId' @infinite='infiniteHandler')
        //-   IconLoading(slot='spinner' :size='30' :color='`#b1b1b1`')
        //-   div.infinite-scroll-slot(slot='no-more' style='display: n one; font-size: 0')
        //-   div.infinite-scroll-slot(slot='no-results' style='display: none; font-size: 0')


</template>

<script>
import axios from 'axios';
import { mapMutations, mapGetters } from 'vuex';

import IconLoading from '../../icon/Loading';
import IconConfirm from '../../icon/Confirm';
import IconOpenArrow from '../../icon/OpenArrow';

import GlobalEmitter from 'tiny-emitter/instance';

import {
  putChatConsultRoomList,
  putUpdateChatHistoryList,
  postAssignVendorReply,
} from '../../../js/restapi';

export default {
  components: {
    IconLoading,
    IconConfirm,
    IconOpenArrow,
  },

  props: {
    detail: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      preloading: true,
      consultRooms: [],
    };
  },

  mounted() {
    this.axiosLoadConsultRoomList();
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopChatAdditionalStatus: 'global/POPCHAT_ADDITIONAL_STATUS',
    }),

    handleClosePopBox() {
      this.changePopChatAdditionalStatus({
        active: false,
        room: '',
        msgId: '',
      });
    },

    sendChatAdditional(teamId) {
      this.changePopBoxStatus({
        active: false,
        include: 'sendChatAdditional',
      });

      this.updateMessageStatus(teamId);

      setTimeout(() => {
        this.changePopBoxStatus({
          active: false,
          include: '',
        });
        this.handleClosePopBox();

      }, this.POP_DURATION);
    },

    updateMessageStatus(teamId) {
      console.log('updateMessageStatus', this.detail.message_id, this.detail.room);

      const UPDATE_CONFIG = {
        message_id: this.detail.message_id,
        room: this.detail.room,
        real_reply: true,
      };

      const SEND_MSG = {
        room: `${teamId}-${this.loginHashCode}-${this.loginDjangoId}`,
        username: this.loginDjangoId,
        content: this.detail.message,
        notes: this.detail.notes,
        extra_text: this.detail.extra_text
      };

      axios.all([
        postAssignVendorReply('', SEND_MSG),
        putUpdateChatHistoryList('', UPDATE_CONFIG)
      ])
        .then(axios.spread((sendData, updateData) => {
          console.log('aaaa', sendData, updateData);
          GlobalEmitter.emit('send-chat-additional', {
            msgId: this.detail.message_id,
          });
        }))
        .catch((err) => {
          console.log('aaaa');
        });
    },

    axiosLoadConsultRoomList() {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      const CONFIG = {
        headers: {
          'content-Type': 'application/json',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      };

      putChatConsultRoomList('', CONFIG)
        .then((res) => {
          res.data.map((x) => {
            if (x.team_id !== '0') {
              this.consultRooms.push(x);
            }
          });
          this.preloading = false;
          console.log('Load Consult Room');
        })
        .catch((err) => {
          this.preloading = false;
        });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      loginDjangoId: 'user/exportUserDjangoId',
      loginProfile: 'user/exportUserProfile',
      loginHashCode: 'user/exportUserHashCode',
      authJwtToken: 'user/exportUserJwtToken',
      consultWebSocket: 'user/exportConsultWebSocket',
    }),
  },

  // ...mapGetters({
  //     rwdType: 'global/exportRwdType',
  //     loginDjangoId: 'user/exportUserDjangoId',
  //     loginStatus: 'user/exportLoginStatus',
  //     loginProfile: 'user/exportUserProfile',
  //     // authJwtToken: 'user/exportUserJwtToken',
  //     subscribeVip: 'user/exportUserSubscribeVip',
  //     loginHashCode: 'user/exportUserHashCode',
  //   }),
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popChatAdditionalVendor.scss';
</style>
